// // import React, { useState } from "react";
// // import {
// //   FaSearch,
// //   FaShoppingCart,
// //   FaBars,
// //   FaTimes,
// //   FaBoxOpen,
// // } from "react-icons/fa";
// // import { motion, AnimatePresence } from "framer-motion";
// // import { useSelector } from "react-redux";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import Logo from "../assets/Pi7_Tool_whitelogo.png";

// // const Navbar = ({
// //   showSearch = false,
// //   showSearchButton = false,
// //   search = "",
// //   setSearch,
// // }) => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [searchOpen, setSearchOpen] = useState(false);
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const cartItems = useSelector((state) => state.cart.items);
// //   const activePath = location.pathname;
// //   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

// //   const gradient = "bg-gradient-to-r from-[#542757] to-[#9b1f6c]";
// //   const buttonHover = { scale: 1.2 };
// //   const buttonTap = { scale: 0.9 };

// //   // Tabs list
// //   const tabs = [
// //     { label: "Home", path: "/" },
// //     { label: "Shop Now", path: "/shop" },
// //     { label: "Categories", path: "/categories" },
// //     { label: "Solutions", path: "/solutions" },
// //     { label: "Calculator", path: "/calculator" },
// //     { label: "Become a Dealer", path: "/dealer" },
// //     { label: "Blogs", path: "/blogs" },
// //     { label: "About Us", path: "/about" },
// //     { label: "Contact Us", path: "/contact" },
// //   ];

// //   return (
// //     <motion.nav
// //       initial={{ y: -60, opacity: 0 }}
// //       animate={{ y: 0, opacity: 1 }}
// //       transition={{ duration: 0.6 }}
// //       className={`w-full fixed top-0 left-0 z-50 shadow-md ${gradient} border-b border-white`}
// //     >
// //       <div className="max-w-7xl mx-auto flex items-center justify-between px-6 h-16">

// //         {/* Logo */}
// //  <motion.div
// //   className="flex items-center space-x-3 cursor-pointer overflow-hidden"
// //   onClick={() => navigate("/")}
// //   whileHover={{ scale: 1.3 }}
// //   whileTap={{ scale: 0.95 }}
// // >
// //   <motion.img
// //     src={Logo}
// //     alt="Logo"
// //     className="w-24 h-24 md:w-30 md:h-30 object-contain"
// //   />
// // </motion.div>


// //         {/* Desktop Tabs */}
// //         <ul className="hidden md:flex items-center space-x-6 text-[16px] font-medium text-white">
// //           {tabs.map((tab) => {
// //             const isActive = activePath === tab.path;
// //             return (
// //               <motion.li
// //                 key={tab.path}
// //                 onClick={() => navigate(tab.path)}
// //                 className={`cursor-pointer transition ${
// //                   isActive
// //                     ? "font-semibold underline underline-offset-4"
// //                     : "hover:text-gray-200"
// //                 }`}
// //                 whileHover={{ scale: 1.15 }}
// //                 whileTap={{ scale: 0.95 }}
// //               >
// //                 {tab.label}
// //               </motion.li>
// //             );
// //           })}
// //         </ul>

// //         {/* Desktop Icons */}
// //         <div className="hidden md:flex items-center space-x-3">
// //           {showSearchButton && search && (
// //             <motion.button
// //               onClick={() => setSearchOpen(!searchOpen)}
// //               className="p-2 rounded-md overflow-hidden"
// //               whileHover={buttonHover}
// //               whileTap={buttonTap}
// //             >
// //               <FaSearch size={16} className="text-white" />
// //             </motion.button>
// //           )}
// //           <motion.button
// //             onClick={() => navigate("/orders")}
// //             className="flex items-center gap-1.5 p-2 rounded-md overflow-hidden"
// //             whileHover={buttonHover}
// //             whileTap={buttonTap}
// //             aria-label="My Orders"
// //             title="My Orders"
// //           >
// //             <FaBoxOpen size={16} className="text-white" />
// //             <span className="text-white text-sm font-medium">My Orders</span>
// //           </motion.button>
// //     <motion.button
// //   onClick={() => navigate("/cart")}
// //   className="relative p-2 rounded-md"
// //   whileHover={buttonHover}
// //   whileTap={buttonTap}
// // >
// //   <div className="relative">
// //     <FaShoppingCart size={16} className="text-white" />

// //     {cartItems.length > 0 && (
// //       <span className="absolute -top-2 -right-3 w-4 h-4 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
// //         {cartItems.length}
// //       </span>
// //     )}
// //   </div>
// // </motion.button>

// //         </div>

// //         {/* Mobile Icons */}
// //         <div className="flex md:hidden items-center space-x-3">
// //           <motion.button
// //             onClick={() => navigate("/orders")}
// //             className=" relative p-2 rounded-md"
// //             whileHover={buttonHover}
// //             whileTap={buttonTap}
// //             aria-label="My Orders"
// //             title="My Orders"
// //           >
// //             <FaBoxOpen size={16} className="text-white" />
// //           </motion.button>
// //    <motion.button
// //   onClick={() => navigate("/cart")}
// //   className="relative p-2 rounded-md"
// //   whileHover={buttonHover}
// //   whileTap={buttonTap}
// // >
// //   <div className="relative">
// //     <FaShoppingCart size={16} className="text-white" />

// //     {cartItems.length > 0 && (
// //       <span className="absolute -top-2 -right-2 w-5 h-5 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
// //         {cartItems.length}
// //       </span>
// //     )}
// //   </div>
// // </motion.button>

// //           <motion.button
// //             onClick={toggleMenu}
// //             className="p-2 hover:bg-white/20 rounded-md transition"
// //             whileHover={buttonHover}
// //             whileTap={buttonTap}
// //           >
// //             {isMenuOpen ? <FaTimes size={18} className="text-white" /> : <FaBars size={18} className="text-white" />}
// //           </motion.button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       <AnimatePresence>
// //         {isMenuOpen && (
// //           <motion.div
// //             initial={{ height: 0, opacity: 0 }}
// //             animate={{ height: "auto", opacity: 1 }}
// //             exit={{ height: 0, opacity: 0 }}
// //             className={`md:hidden overflow-hidden ${gradient}`}
// //           >
// //             <ul className="py-4 px-6 space-y-4 text-[16px] font-medium text-white">
// //               {tabs.map((tab) => {
// //                 const isActive = activePath === tab.path;
// //                 return (
// //                   <motion.li
// //                     key={tab.path}
// //                     onClick={() => {
// //                       navigate(tab.path);
// //                       setIsMenuOpen(false);
// //                     }}
// //                     className={`cursor-pointer transition ${
// //                       isActive
// //                         ? "font-semibold underline underline-offset-4"
// //                         : "hover:text-gray-200"
// //                     }`}
// //                     whileHover={{ scale: 1.1 }}
// //                     whileTap={{ scale: 0.95 }}
// //                   >
// //                     {tab.label}
// //                   </motion.li>
// //                 );
// //               })}
// //             </ul>
// //           </motion.div>
// //         )}
// //       </AnimatePresence>
// //     </motion.nav>
// //   );
// // };

// // export default Navbar;


// import React, { useState, useRef, useLayoutEffect } from "react";
// import {
//   FaSearch,
//   FaShoppingCart,
//   FaBars,
//   FaTimes,
//   FaBoxOpen,
// } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";
// import { useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import Logo from "../assets/Pi7_Tool_whitelogo.png";

// const Navbar = ({
//   showSearch = false,
//   showSearchButton = false,
//   search = "",
//   setSearch,
// }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [searchOpen, setSearchOpen] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const cartItems = useSelector((state) => state.cart.items);
//   const activePath = location.pathname;
//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
//   const navRef = useRef(null);

//   /* ------------------------------------------------------------
//      Publish this navbar's REAL rendered height as --nav-h on the
//      document root. HeroSection.css positions its scene at
//      `top: var(--nav-h)` — if that variable is a guess instead of
//      the actual measured height, any change to the logo, tab count,
//      or mobile menu makes the hero content sit under (or too far
//      below) the fixed nav. Measuring it live fixes that permanently,
//      at every breakpoint, without hand-tuned pixel values.
//      ------------------------------------------------------------ */
//   useLayoutEffect(() => {
//     const el = navRef.current;
//     if (!el) return;
//     const setVar = () => {
//       document.documentElement.style.setProperty("--nav-h", `${el.offsetHeight}px`);
//     };
//     setVar();
//     const ro = new ResizeObserver(setVar);
//     ro.observe(el);
//     return () => ro.disconnect();
//   }, [isMenuOpen]);

//   const gradient = "bg-gradient-to-r from-[#542757] to-[#9b1f6c]";
//   const buttonHover = { scale: 1.2 };
//   const buttonTap = { scale: 0.9 };

//   // Tabs list
//   const tabs = [
//     { label: "Home", path: "/" },
//     { label: "Shop Now", path: "/shop" },
//     { label: "Categories", path: "/categories" },
//     { label: "Solutions", path: "/solutions" },
//     { label: "Calculator", path: "/calculator" },
//     { label: "Become a Dealer", path: "/dealer" },
//     { label: "Blogs", path: "/blogs" },
//     { label: "About Us", path: "/about" },
//     { label: "Contact Us", path: "/contact" },
//   ];

//   return (
//     <motion.nav
//       ref={navRef}
//       initial={{ y: -60, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       transition={{ duration: 0.6 }}
//       className={`w-full fixed top-0 left-0 z-50 shadow-md ${gradient} border-b border-white`}
//     >
//       <div className="max-w-7xl mx-auto flex items-center justify-between px-6 h-16">

//         {/* Logo — capped to a sane height so it can never overflow
//             the h-16 row and push real nav height past what the hero
//             expects. 40px matches the reference design's nav logo. */}
//         <motion.div
//           className="flex items-center space-x-3 cursor-pointer"
//           onClick={() => navigate("/")}
//           whileHover={{ scale: 1.08 }}
//           whileTap={{ scale: 0.95 }}
//         >
//           <motion.img
//             src={Logo}
//             alt="Logo"
//             className="h-9 md:h-10 w-auto object-contain"
//           />
//         </motion.div>


//         {/* Desktop Tabs */}
//         <ul className="hidden md:flex items-center space-x-6 text-[16px] font-medium text-white">
//           {tabs.map((tab) => {
//             const isActive = activePath === tab.path;
//             return (
//               <motion.li
//                 key={tab.path}
//                 onClick={() => navigate(tab.path)}
//                 className={`cursor-pointer transition ${
//                   isActive
//                     ? "font-semibold underline underline-offset-4"
//                     : "hover:text-gray-200"
//                 }`}
//                 whileHover={{ scale: 1.15 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 {tab.label}
//               </motion.li>
//             );
//           })}
//         </ul>

//         {/* Desktop Icons */}
//         <div className="hidden md:flex items-center space-x-3">
//           {showSearchButton && search && (
//             <motion.button
//               onClick={() => setSearchOpen(!searchOpen)}
//               className="p-2 rounded-md overflow-hidden"
//               whileHover={buttonHover}
//               whileTap={buttonTap}
//             >
//               <FaSearch size={16} className="text-white" />
//             </motion.button>
//           )}
//           <motion.button
//             onClick={() => navigate("/orders")}
//             className="flex items-center gap-1.5 p-2 rounded-md overflow-hidden"
//             whileHover={buttonHover}
//             whileTap={buttonTap}
//             aria-label="My Orders"
//             title="My Orders"
//           >
//             <FaBoxOpen size={16} className="text-white" />
//             <span className="text-white text-sm font-medium">My Orders</span>
//           </motion.button>
//     <motion.button
//   onClick={() => navigate("/cart")}
//   className="relative p-2 rounded-md"
//   whileHover={buttonHover}
//   whileTap={buttonTap}
// >
//   <div className="relative">
//     <FaShoppingCart size={16} className="text-white" />

//     {cartItems.length > 0 && (
//       <span className="absolute -top-2 -right-3 w-4 h-4 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
//         {cartItems.length}
//       </span>
//     )}
//   </div>
// </motion.button>

//         </div>

//         {/* Mobile Icons */}
//         <div className="flex md:hidden items-center space-x-3">
//           <motion.button
//             onClick={() => navigate("/orders")}
//             className=" relative p-2 rounded-md"
//             whileHover={buttonHover}
//             whileTap={buttonTap}
//             aria-label="My Orders"
//             title="My Orders"
//           >
//             <FaBoxOpen size={16} className="text-white" />
//           </motion.button>
//    <motion.button
//   onClick={() => navigate("/cart")}
//   className="relative p-2 rounded-md"
//   whileHover={buttonHover}
//   whileTap={buttonTap}
// >
//   <div className="relative">
//     <FaShoppingCart size={16} className="text-white" />

//     {cartItems.length > 0 && (
//       <span className="absolute -top-2 -right-2 w-5 h-5 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
//         {cartItems.length}
//       </span>
//     )}
//   </div>
// </motion.button>

//           <motion.button
//             onClick={toggleMenu}
//             className="p-2 hover:bg-white/20 rounded-md transition"
//             whileHover={buttonHover}
//             whileTap={buttonTap}
//           >
//             {isMenuOpen ? <FaTimes size={18} className="text-white" /> : <FaBars size={18} className="text-white" />}
//           </motion.button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       <AnimatePresence>
//         {isMenuOpen && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             className={`md:hidden overflow-hidden ${gradient}`}
//           >
//             <ul className="py-4 px-6 space-y-4 text-[16px] font-medium text-white">
//               {tabs.map((tab) => {
//                 const isActive = activePath === tab.path;
//                 return (
//                   <motion.li
//                     key={tab.path}
//                     onClick={() => {
//                       navigate(tab.path);
//                       setIsMenuOpen(false);
//                     }}
//                     className={`cursor-pointer transition ${
//                       isActive
//                         ? "font-semibold underline underline-offset-4"
//                         : "hover:text-gray-200"
//                     }`}
//                     whileHover={{ scale: 1.1 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     {tab.label}
//                   </motion.li>
//                 );
//               })}
//             </ul>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.nav>
//   );
// };

// export default Navbar;

import React, { useState, useRef, useLayoutEffect } from "react";
import {
  FaSearch,
  FaShoppingCart,
  FaBars,
  FaTimes,
  FaBoxOpen,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Logo from "../assets/Pi7_Tool_whitelogo.png";

const Navbar = ({
  showSearch = false,
  showSearchButton = false,
  search = "",
  setSearch,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const cartItems = useSelector((state) => state.cart.items);
  const activePath = location.pathname;
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navRef = useRef(null);

  /* Publish this navbar's real rendered height as --nav-h so
     HeroSection's `top: var(--nav-h)` always clears it exactly,
     at any breakpoint, regardless of content changes. */
  useLayoutEffect(() => {
    const el = navRef.current;
    if (!el) return;
    const setVar = () => {
      document.documentElement.style.setProperty("--nav-h", `${el.offsetHeight}px`);
    };
    setVar();
    const ro = new ResizeObserver(setVar);
    ro.observe(el);
    return () => ro.disconnect();
  }, [isMenuOpen]);

  const buttonHover = { scale: 1.15 };
  const buttonTap = { scale: 0.92 };

  const tabs = [
    { label: "Home", path: "/" },
    { label: "Shop Now", path: "/shop" },
    { label: "Categories", path: "/categories" },
    { label: "Solutions", path: "/solutions" },
    { label: "Calculator", path: "/calculator" },
    { label: "Become a Dealer", path: "/dealer" },
    { label: "Blogs", path: "/blogs" },
    { label: "About Us", path: "/about" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <motion.nav
      ref={navRef}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="hlc-site-nav w-full fixed top-0 left-0 z-50 bg-[#0A0510] border-b border-[#9b1f6c]/35"
      onKeyDown={(event) => {
        if (event.key === "Escape" && isMenuOpen) {
          setIsMenuOpen(false);
          navRef.current?.querySelector('[aria-controls="hlc-mobile-navigation"]')?.focus();
        }
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-10 lg:px-14 h-[74px]">

        {/* Logo — small mark, like the reference's 34px nav-logo-mark */}
        <motion.div
          className="flex items-center cursor-pointer"
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link to="/" aria-label="HLC home" className="inline-flex min-h-11 items-center">
          <motion.img
            src={Logo}
            alt="HLC"
            className="h-8 w-auto object-contain"
          />
          </Link>
        </motion.div>

        {/* Desktop Tabs — 14px / weight 500, quiet underline on active
            instead of the browser-default underline */}
        <ul className="hidden xl:flex items-center gap-4 lg:gap-7 text-[14px] font-medium">
          {tabs.map((tab) => {
            const isActive = activePath === tab.path;
            return (
              <motion.li
                key={tab.path}
                className={`relative cursor-pointer whitespace-nowrap pb-1.5 transition-colors ${
                  isActive
                    ? "text-white font-semibold"
                    : "text-white/85 hover:text-white"
                }`}
                whileHover={{ scale: 1.06 }}
                whileTap={{ scale: 0.96 }}
              >
                <Link to={tab.path} aria-current={isActive ? "page" : undefined} className="inline-flex min-h-11 items-center">{tab.label}</Link>
                {isActive && (
                  <span className="absolute left-0 right-0 -bottom-0.5 h-[2px] bg-[#9b1f6c] rounded-full" />
                )}
              </motion.li>
            );
          })}
        </ul>

        {/* Desktop Icons — quieter, matches reference's icon opacity/size */}
        <div className="hidden xl:flex items-center gap-[18px] text-white">
          {showSearchButton && search && (
            <motion.button
              onClick={() => setSearchOpen(!searchOpen)}
              type="button"
              aria-label="Toggle product search"
              className="opacity-90 hover:opacity-100 transition-opacity"
              whileHover={buttonHover}
              whileTap={buttonTap}
            >
              <FaSearch size={17} />
            </motion.button>
          )}
          <motion.button
            onClick={() => navigate("/orders")}
            className="flex items-center gap-1.5 opacity-90 hover:opacity-100 transition-opacity"
            whileHover={buttonHover}
            whileTap={buttonTap}
            aria-label="My Orders"
            title="My Orders"
          >
            <FaBoxOpen size={17} />
            <span className="text-[13px] font-medium">My Orders</span>
          </motion.button>
          <motion.button
            onClick={() => navigate("/cart")}
            type="button"
            aria-label="View cart"
            className="relative opacity-90 hover:opacity-100 transition-opacity"
            whileHover={buttonHover}
            whileTap={buttonTap}
          >
            <FaShoppingCart size={17} />
            {cartItems.length > 0 && (
              <span className="absolute -top-2 -right-2.5 w-4 h-4 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
                {cartItems.length}
              </span>
            )}
          </motion.button>
        </div>

        {/* Mobile Icons */}
        <div className="flex xl:hidden items-center gap-3 text-white">
          <motion.button
            onClick={() => navigate("/orders")}
            className="relative p-1.5"
            whileHover={buttonHover}
            whileTap={buttonTap}
            aria-label="My Orders"
            title="My Orders"
          >
            <FaBoxOpen size={16} />
          </motion.button>
          <motion.button
            onClick={() => navigate("/cart")}
            type="button"
            aria-label="View cart"
            className="relative p-1.5"
            whileHover={buttonHover}
            whileTap={buttonTap}
          >
            <FaShoppingCart size={16} />
            {cartItems.length > 0 && (
              <span className="absolute -top-1 -right-0.5 w-4 h-4 text-[10px] bg-white text-[#9b1f6c] rounded-full flex items-center justify-center font-bold">
                {cartItems.length}
              </span>
            )}
          </motion.button>
          <motion.button
            onClick={toggleMenu}
            type="button"
            aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMenuOpen}
            aria-controls="hlc-mobile-navigation"
            className="p-1.5 hover:bg-white/10 rounded-md transition"
            whileHover={buttonHover}
            whileTap={buttonTap}
          >
            {isMenuOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
          </motion.button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            id="hlc-mobile-navigation"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="xl:hidden max-h-[calc(100dvh-74px)] overflow-y-auto bg-[#17091c] border-t border-[#9b1f6c]/25"
          >
            <ul className="py-4 px-6 space-y-4 text-[15px] font-medium text-white">
              {tabs.map((tab) => {
                const isActive = activePath === tab.path;
                return (
                  <motion.li
                    key={tab.path}
                    className={`cursor-pointer transition ${
                      isActive
                        ? "font-semibold text-white"
                        : "text-white/80 hover:text-white"
                    }`}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.96 }}
                  >
                    <Link to={tab.path} onClick={() => setIsMenuOpen(false)} aria-current={isActive ? "page" : undefined} className="flex min-h-11 items-center">{tab.label}</Link>
                  </motion.li>
                );
              })}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
